import React, { Component } from "react";
import { Admin, Resource} from "react-admin";

import FirmwareIcon from '@mui/icons-material/Memory';
import JobIcon from '@mui/icons-material/Assignment';

import AuthProvider from './Providers/AuthProvider';
import Dashboard from './Components/Dashboard';

import {FirmwareList} from "./Components/Resources/Firmwares/FirmwareList";
import {FirmwareCreate} from "./Components/Resources/Firmwares/FirmwareCreate";
import {EventLogList} from "./Components/Resources/Events/Event_logsList";
import {HydrantList} from "./Components/Resources/Hydrants/HydrantList";
import {ClientList} from "./Components/Resources/Clients/ClientList";
import {FirmwareJobList} from "./Components/Resources/FirmwareJobs/FirmwareJobList";
import {FirmwareJobCreate} from "./Components/Resources/FirmwareJobs/FirmwareJobCreate";
import {ClientCreate} from "./Components/Resources/Client/ClientCreate";
import dataProvider from './Providers/DataProvider';

class App extends Component {
  render() {
    return (
      <Admin 
        title='Hydrant Fleet Management' 
        dataProvider={dataProvider} 
        dashboard={Dashboard}
        authProvider = {AuthProvider}
      >
        <Resource name="hydrant" list={HydrantList} />
        <Resource name="clients" list={ClientList} />
        <Resource name="firmwares" list={FirmwareList} create={FirmwareCreate} icon={FirmwareIcon}/>
        <Resource name="jobs" list={FirmwareJobList} create={FirmwareJobCreate} icon={JobIcon}/>
        <Resource name="clients" list={ClientList} create={ClientCreate}/>
        <Resource name="events" list={EventLogList}/>
      </Admin>
    );
  }
}
export default App;